import moment from 'moment';
let searchDate = moment().startOf().format('YYYYMMDD');

export default {
	masterInfo: MASTER_INFO(),
	searchParams: SEARCH_PARAMS(),
	excelDownLoadList: [], //엑셀다운로드시 해더저장
	gridList: [],
	groups: GROUPS()
};
function GROUPS() {
	return {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	};
}
function SEARCH_PARAMS() {
	return {
		pmcId: '', // 제품번호
		carVin:''
	};
}
function MASTER_INFO() {
	return {
		pmcNo: '', //제품번호
		pmcId: '', //제품ID
		plntCd: '', //생산공장
		plntNm: '', //생산공장명
		htwoCorp: '', //생산법인
		htwoCorpNm: '', //생산법임명
		erpProdDd: '', // HTWO생산일
		flclSpc: '', //연료전지사양
		flclSpcNm: '', //연료전지사양명
		carScn: '', //차량구분
		carScnNm: '', //차량구분명
		erpSaleDd: '', //HTWO판매일
		carTypeNm: '', //제품유형
		jvWsDt: '', //jv입고일
		jvSaleDd: '', //jv판매일
		pwrTypeNm: '', //동력유형
		custNm: '', //고객사
		oemProdDd: '', //OEM생산일
		zwPeriodMilg: '', //보증조건
		saleNat: '', //판매국가
		oemSaleDd: '', //OEM판매일.
		saleNatNm: '',
		usePrd: '',
		milg: '',
		cmpnNm: ''
	};
}
export { SEARCH_PARAMS, GROUPS, MASTER_INFO };
